import { render, staticRenderFns } from "./StatusPill.vue?vue&type=template&id=605c6c45"
import script from "./StatusPill.vue?vue&type=script&lang=js"
export * from "./StatusPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports